import { useEffect } from "react";

const SEL = ".h-section, .h-hero, .spc, .glass-heavy, .btn-primary, .reveal-frame";
const clamp = (v, m) => Math.max(-m, Math.min(m, v));

export const useVfx = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.classList.add("is-inview");
          io.unobserve(e.target);
        }),
      { rootMargin: "0px 0px -10% 0px" }
    );
    const seen = new WeakSet();
    const scan = () =>
      document.querySelectorAll(SEL).forEach((el) => {
        if (seen.has(el)) return;
        seen.add(el);
        if (!el.classList.contains("is-inview") && el.getBoundingClientRect().top > window.innerHeight * 0.9) el.classList.add("will-reveal");
        io.observe(el);
      });
    const passed = () =>
      document.querySelectorAll(".will-reveal:not(.is-inview)").forEach((el) => {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add("is-inview");
      });
    scan();
    const iv = setInterval(() => { scan(); passed(); }, 1500);
    let st = 0;
    const onScroll = () => { clearTimeout(st); st = setTimeout(passed, 120); };
    window.addEventListener("scroll", onScroll, { passive: true });

    let raf = 0;
    let last = null;
    let mag = null;
    const tick = () => {
      raf = 0;
      const e = last;
      const t = e.target instanceof Element ? e.target : null;
      const glass = t?.closest(".glass, .spc");
      if (glass) {
        const r = glass.getBoundingClientRect();
        glass.style.setProperty("--mx", `${e.clientX - r.left}px`);
        glass.style.setProperty("--my", `${e.clientY - r.top}px`);
      }
      const btn = t?.closest(".btn-primary");
      if (mag && mag !== btn) {
        mag.style.setProperty("--tx", "0px");
        mag.style.setProperty("--ty", "0px");
      }
      mag = btn;
      if (btn) {
        const r = btn.getBoundingClientRect();
        btn.style.setProperty("--tx", `${clamp((e.clientX - r.left - r.width / 2) * 0.2, 8)}px`);
        btn.style.setProperty("--ty", `${clamp((e.clientY - r.top - r.height / 2) * 0.3, 6)}px`);
      }
    };
    const onMove = (e) => {
      last = e;
      if (!raf) raf = requestAnimationFrame(tick);
    };
    if (fine) window.addEventListener("pointermove", onMove, { passive: true });
    return () => {
      clearInterval(iv);
      clearTimeout(st);
      window.removeEventListener("scroll", onScroll);
      io.disconnect();
      cancelAnimationFrame(raf);
      window.removeEventListener("pointermove", onMove);
    };
  }, []);
};
